<div class="row">
    <div class="col-12">
        @if (dashboardStats(); as dashboardStats) {
            <div class="bg-primary bg-opacity-25 p-3 sf-insights rounded-3 mb-3">
                <div class="mb-3 border-bottom border-primary">
                    <h3>Insights</h3>
                </div>

                <div class="row g-4">
                    <div class="col-lg-4">
                        <div class="sf-insights__item">
                            <div>
                                <h5 class="text-dark mb-0">Appliances</h5>
                            </div>
                            <div>
                                <span>
                                    {{ dashboardStats.appliancesCount | number }}
                                </span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span>Contract Appliances</span>
                            </div>
                            <div>
                                <span>
                                    {{ dashboardStats.contractAppliances | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Contract Appliances
                                    <span class="small text-body-secondary">(Expiring Soon)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.contractAppliancesExpiringSoon > 0"
                                    [class.text-success]="dashboardStats.contractAppliancesExpiringSoon === 0">
                                    {{ dashboardStats.contractAppliancesExpiringSoon | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Service Due <span class="small text-body-secondary">(today)</span></span>
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.serviceRemindersDueToday > 0"
                                    [class.text-success]="dashboardStats.serviceRemindersDueToday === 0">
                                    {{ dashboardStats.serviceRemindersDueToday | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Service Due <span class="small text-body-secondary">(within 30 days)</span></span>
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.serviceRemindersDue30Days > 0"
                                    [class.text-success]="dashboardStats.serviceRemindersDue30Days === 0">
                                    {{ dashboardStats.serviceRemindersDue30Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Service Due <span class="small text-body-secondary">(within 90 days)</span></span>
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.serviceRemindersDue90Days > 0"
                                    [class.text-success]="dashboardStats.serviceRemindersDue90Days === 0">
                                    {{ dashboardStats.serviceRemindersDue90Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>LGSC Due <span class="small text-body-secondary">(today)</span></span>
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.lgscRemindersDueToday > 0"
                                    [class.text-success]="dashboardStats.lgscRemindersDueToday === 0">
                                    {{ dashboardStats.lgscRemindersDueToday | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>LGSC Due <span class="small text-body-secondary">(within 30 days)</span></span>
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.lgscRemindersDue30Days > 0"
                                    [class.text-success]="dashboardStats.lgscRemindersDue30Days === 0">
                                    {{ dashboardStats.lgscRemindersDue30Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>LGSC Due <span class="small text-body-secondary">(within 90 days)</span></span>
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.lgscRemindersDue90Days > 0"
                                    [class.text-success]="dashboardStats.lgscRemindersDue90Days === 0">
                                    {{ dashboardStats.lgscRemindersDue90Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Warranty Expiry <span class="small text-body-secondary">(today)</span></span>
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.warrantyRemindersExpireToday > 0"
                                    [class.text-success]="dashboardStats.warrantyRemindersExpireToday === 0">
                                    {{ dashboardStats.warrantyRemindersExpireToday | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Warranty Expiry
                                    <span class="small text-body-secondary">(within 30 days)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.warrantyRemindersExpire30Days > 0"
                                    [class.text-success]="dashboardStats.warrantyRemindersExpire30Days === 0">
                                    {{ dashboardStats.warrantyRemindersExpire30Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Warranty Expiry
                                    <span class="small text-body-secondary">(within 90 days)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.warrantyRemindersExpire90Days > 0"
                                    [class.text-success]="dashboardStats.warrantyRemindersExpire90Days === 0">
                                    {{ dashboardStats.warrantyRemindersExpire90Days | number }}
                                </span>
                            </div>
                        </div>

                        <div class="sf-insights__item mt-3">
                            <div>
                                <h5 class="text-dark mb-0">Appliance Reminders Sent</h5>
                            </div>
                            <div>
                                <span> </span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Service Reminders Sent
                                    <span class="small text-body-secondary">(last 7 days)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-success]="dashboardStats.applianceServiceRemindersSentLast7Days > 0"
                                    [class.text-danger]="dashboardStats.applianceServiceRemindersSentLast7Days === 0">
                                    {{ dashboardStats.applianceServiceRemindersSentLast7Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Service Reminders Sent
                                    <span class="small text-body-secondary">(last 28 days)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-success]="dashboardStats.applianceServiceRemindersSentLast28Days > 0"
                                    [class.text-danger]="dashboardStats.applianceServiceRemindersSentLast28Days === 0">
                                    {{ dashboardStats.applianceServiceRemindersSentLast28Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >LGSC Reminders Sent
                                    <span class="small text-body-secondary">(last 7 days)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-success]="dashboardStats.applianceLGSCRemindersSentLast7Days > 0"
                                    [class.text-danger]="dashboardStats.applianceLGSCRemindersSentLast7Days === 0">
                                    {{ dashboardStats.applianceLGSCRemindersSentLast7Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >LGSC Reminders Sent
                                    <span class="small text-body-secondary">(last 28 days)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-success]="dashboardStats.applianceLGSCRemindersSentLast28Days > 0"
                                    [class.text-danger]="dashboardStats.applianceLGSCRemindersSentLast28Days === 0">
                                    {{ dashboardStats.applianceLGSCRemindersSentLast28Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Warranty Reminders Sent
                                    <span class="small text-body-secondary">(last 7 days)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-success]="dashboardStats.applianceWarrantyRemindersSentLast7Days > 0"
                                    [class.text-danger]="dashboardStats.applianceWarrantyRemindersSentLast7Days === 0">
                                    {{ dashboardStats.applianceWarrantyRemindersSentLast7Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Warranty Reminders Sent
                                    <span class="small text-body-secondary">(last 28 days)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-success]="dashboardStats.applianceWarrantyRemindersSentLast28Days > 0"
                                    [class.text-danger]="dashboardStats.applianceWarrantyRemindersSentLast28Days === 0">
                                    {{ dashboardStats.applianceWarrantyRemindersSentLast28Days | number }}
                                </span>
                            </div>
                        </div>

                        <div class="sf-insights__item mt-3">
                            <div>
                                <h5 class="text-dark mb-0">AC Appliances</h5>
                            </div>
                            <div>
                                <span>
                                    {{ dashboardStats.acAppliancesCount | number }}
                                </span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span>Service Due <span class="small text-body-secondary">(today)</span></span>
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.acServiceRemindersDueToday > 0"
                                    [class.text-success]="dashboardStats.acServiceRemindersDueToday === 0">
                                    {{ dashboardStats.acServiceRemindersDueToday | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Service Due <span class="small text-body-secondary">(within 30 days)</span></span>
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.acServiceRemindersDue30Days > 0"
                                    [class.text-success]="dashboardStats.acServiceRemindersDue30Days === 0">
                                    {{ dashboardStats.acServiceRemindersDue30Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Service Due <span class="small text-body-secondary">(within 90 days)</span></span>
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.acServiceRemindersDue90Days > 0"
                                    [class.text-success]="dashboardStats.acServiceRemindersDue90Days === 0">
                                    {{ dashboardStats.acServiceRemindersDue90Days | number }}
                                </span>
                            </div>
                        </div>

                        <div class="sf-insights__item mt-3">
                            <div>
                                <h5 class="text-dark mb-0">AC Appliance Reminders Sent</h5>
                            </div>
                            <div>
                                <span> </span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Service Reminders Sent
                                    <span class="small text-body-secondary">(last 7 days)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-success]="dashboardStats.acApplianceServiceRemindersSentLast7Days > 0"
                                    [class.text-danger]="dashboardStats.acApplianceServiceRemindersSentLast7Days === 0">
                                    {{ dashboardStats.acApplianceServiceRemindersSentLast7Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Service Reminders Sent
                                    <span class="small text-body-secondary">(last 28 days)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-success]="dashboardStats.acApplianceServiceRemindersSentLast28Days > 0"
                                    [class.text-danger]="
                                        dashboardStats.acApplianceServiceRemindersSentLast28Days === 0
                                    ">
                                    {{ dashboardStats.acApplianceServiceRemindersSentLast28Days | number }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="sf-insights__item">
                            <div>
                                <h5 class="text-dark mb-0">Appointments</h5>
                            </div>
                            <div>
                                <span> </span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span>Appointments <span class="small text-body-secondary">(today)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.appointmentsToday | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>In Progress</span>
                            </div>
                            <div>
                                {{ dashboardStats.appointmentsInProgressToday | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Currently En-Route</span>
                            </div>
                            <div>
                                {{ dashboardStats.appointmentsEnrouteToday | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Completed <span class="small text-body-secondary">(today)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.appointmentsCompletedToday | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Appointments <span class="small text-body-secondary">(tomorrow)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.appointmentsTomorrow | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Appointments <span class="small text-body-secondary">(next 7 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.appointmentsNext7Days | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Appointments <span class="small text-body-secondary">(next 14 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.appointmentsNext14Days | number }}
                            </div>
                        </div>

                        <div class="sf-insights__item mt-3">
                            <div>
                                <h5 class="text-dark mb-0">Unallocated Appointments</h5>
                            </div>
                            <div>
                                <span>{{ dashboardStats.pendingUnallocatedAppointments | number }} </span>
                            </div>
                        </div>

                        <div class="sf-insights__item mt-3">
                            <div>
                                <h5 class="text-dark mb-0">Smart Quotes</h5>
                            </div>
                            <div>
                                <span></span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Smart Quotes
                                    <span class="small text-body-secondary">(total / accepted / declined)</span></span
                                >
                            </div>
                            <div>
                                {{ dashboardStats.smartQuotes | number }} /
                                <span class="text-success">{{ dashboardStats.smartQuotesAccepted | number }}</span> /
                                <span class="text-danger">{{ dashboardStats.smartQuotesDeclined | number }}</span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Smart Quotes <span class="small text-body-secondary">(last 30 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.smartQuotesLast30Days | number }} /
                                <span class="text-success">{{
                                    dashboardStats.smartQuotesAcceptedLast30Days | number
                                }}</span>
                                /
                                <span class="text-danger">{{
                                    dashboardStats.smartQuotesDeclinedLast30Days | number
                                }}</span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Smart Quotes <span class="small text-body-secondary">(last 90 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.smartQuotesLast90Days | number }} /
                                <span class="text-success">{{
                                    dashboardStats.smartQuotesAcceptedLast90Days | number
                                }}</span>
                                /
                                <span class="text-danger">{{
                                    dashboardStats.smartQuotesDeclinedLast90Days | number
                                }}</span>
                            </div>
                        </div>

                        <div class="sf-insights__item mt-3">
                            <div>
                                <h5 class="text-dark mb-0">Estimates</h5>
                            </div>
                            <div>
                                <span></span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span>Estimates <span class="small text-body-secondary">(all time)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.estimates | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Estimates <span class="small text-body-secondary">(last 7 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.estimatesLast7Days | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Estimates <span class="small text-body-secondary">(last 30 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.estimatesLast28Days | number }}
                            </div>
                        </div>

                        <div class="sf-insights__item mt-3">
                            <div>
                                <h5 class="text-dark mb-0">Surequotes</h5>
                            </div>
                            <div>
                                <span></span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Surequotes
                                    <span class="small text-body-secondary">(impressions / fulfilled)</span></span
                                >
                            </div>
                            <div>
                                {{ dashboardStats.sureQuotesImpressions | number }} /
                                <span class="text-success">
                                    {{ dashboardStats.sureQuotesCompleted | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Surequotes <span class="small text-body-secondary">(last 7 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.sureQuotesImpressionsLast7Days | number }} /
                                <span class="text-success">
                                    {{ dashboardStats.sureQuotesCompletedLast7Days | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Surequotes <span class="small text-body-secondary">(last 30 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.sureQuotesImpressionsLast30Days | number }} /
                                <span class="text-success">
                                    {{ dashboardStats.sureQuotesCompletedLast30Days | number }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="sf-insights__item">
                            <div>
                                <h5 class="text-dark mb-0">Sites</h5>
                            </div>
                            <div>
                                <span>{{ dashboardStats.sites | number }}</span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span>Landlords/Property Managers</span>
                            </div>
                            <div>
                                {{ dashboardStats.landlords | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Tenants</span>
                            </div>
                            <div>
                                {{ dashboardStats.tenants | number }}
                            </div>
                        </div>

                        <div class="sf-insights__item mt-3">
                            <div>
                                <h5 class="text-dark mb-0">Customers</h5>
                            </div>
                            <div>
                                <span>{{ dashboardStats.customers | number }}</span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span>New Customers <span class="small text-body-secondary">(last 7 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.customersAddedLast7Days | number }}
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span>New Customers <span class="small text-body-secondary">(last 30 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.customersAddedLast30Days | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Contract Customers</span>
                            </div>
                            <div>
                                {{ dashboardStats.customersOnContract | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Contract Customers
                                    <span class="small text-body-secondary">(Expiring Soon)</span></span
                                >
                            </div>
                            <div>
                                <span
                                    [class.text-danger]="dashboardStats.contractCustomersExpiringSoon > 0"
                                    [class.text-success]="dashboardStats.contractCustomersExpiringSoon === 0">
                                    {{ dashboardStats.contractCustomersExpiringSoon | number }}
                                </span>
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>MyPlumber App <span class="small text-body-secondary">(Installs)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.customersHaveApp | number }}
                            </div>
                        </div>

                        <div class="sf-insights__item mt-3">
                            <div>
                                <h5 class="text-dark mb-0">Booking Engine</h5>
                            </div>
                            <div>
                                <span></span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span>Booking Engine <span class="small text-body-secondary">(all time)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.bookingEngineBookings | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Booking Engine <span class="small text-body-secondary">(last 7 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.bookingEngineBookingsLast7Days | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span
                                    >Booking Engine <span class="small text-body-secondary">(last 30 days)</span></span
                                >
                            </div>
                            <div>
                                {{ dashboardStats.bookingEngineBookingsLast30Days | number }}
                            </div>
                        </div>

                        <div class="sf-insights__item mt-3">
                            <div>
                                <h5 class="text-dark mb-0">Notifications</h5>
                            </div>
                            <div>
                                <span></span>
                            </div>
                        </div>

                        <div class="sf-insights__item">
                            <div>
                                <span>SMS Sent <span class="small text-body-secondary">(all time)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.smsSent | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>SMS Sent <span class="small text-body-secondary">(today)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.smsSentToday | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>SMS Sent <span class="small text-body-secondary">(last 30 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.smsSentLast30Days | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Emails Sent <span class="small text-body-secondary">(all time)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.emailsSent | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Emails Sent <span class="small text-body-secondary">(today)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.emailsSentToday | number }}
                            </div>
                        </div>
                        <div class="sf-insights__item">
                            <div>
                                <span>Emails Sent <span class="small text-body-secondary">(last 30 days)</span></span>
                            </div>
                            <div>
                                {{ dashboardStats.emailsSentLast30Days | number }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        } @else {
            <p>Loading...</p>
        }
    </div>
</div>
